import daretoleap from "./images/deap.png"
import soundproject from "./images/sound.jpg"
import apple from "./images/apple.jpg"
import lattelove from "./images/whole.png"
import arduino from "./images/wall.jpg"
import midterm from "./images/maze.png"

export const data = [
    "Meera Al Khazraji is a student pursuing a double major in Political Science and Interactive Media at New York University Abu Dhabi, class of 2025",
    "As an Interactive Media major, Meera has developed a keen eye for design and a strong foundation in coding, enabling her to create engaging digital experiences",
    "Her unique interdisciplinary approach helps her bridge the gap between political discourse and modern technology, helping to ensure her future projects not only entertain and inform but also provoke critical thought and discussion",
    "As Meera Al Khazraji continues her studies at NYUAD, she is determined to make her mark as a visionary and influential figure in the world of political science and interactive media"
]

export const projects_data = [
    {
        link: "https://mirasaleh.github.io/video%20project/ind2.html",
        name: "Dare To Leap",
        description: "Interactive video project explores personal growth through choices, emphasizing work-life balance and Tarek's self-discovery.",
        img: {daretoleap},
        github: null
    }
    ,
    {
        link: "https://meerak27.github.io/SoundProject/index.html",
        name: "NYUAD Soundscape",
        description: "Created narrated campus soundscapes for remote users, fostering community and belonging.",
        img: {soundproject},
        github: "https://github.com/meerak27/meerak27.github.io/tree/main/SoundProject"
    },
    {
        link: "https://aibartt.github.io/ComicFinal/",
        name: "The Poisoned Apple",
        description: "Original comic story teaches critical thinking to children through a boy's forest adventure.",
        img: {apple},
        github: "https://github.com/meerak27/meerak27.github.io/tree/main/Project2"
    },
    {
        link: "https://meerak27.github.io/Assignment1/index.html",
        name: "Whole Latte Love",
        description: "Engaging web page showcases short film with story, title, and behind-the-scenes content.",
        img: {lattelove},
        github: "https://github.com/meerak27/meerak27.github.io/blob/main/Assignment1/documentation.md"
    },
    {
        link: "https://vimeo.com/709105224",
        name: "Graffiti Wall",
        description: "Arduino code reads input from various sensors and sends the corresponding values to P5 using web serial.",
        img: {arduino},
        github: "https://github.com/meerak27/Intro-to-IM-/tree/main/Final%20Project"
    },
    {
        link: "https://editor.p5js.org/FatemaAlhameli/full/RcoDaoymz",
        name: "My First Game",
        description: "Timed maze game with a boat navigating to an island amidst a storm, using arrow keys and a time limit, resulting in either a win or loss.",
        img: {midterm},
        github: "https://github.com/meerak27/Intro-to-IM-/tree/main/Midterm%20Project"
    }

]